/* FollicGen — homepage interactions: before/after comparison sliders.
   Reveal-on-scroll, FAQ accordion and sticky header are handled by follicgen.js. */
(function () {
  "use strict";
  if (window.__FG_HOME_BOOTED__) return; window.__FG_HOME_BOOTED__ = true;
  function initBA(ba) {
    var dragging = false;
    function set(x) {
      var r = ba.getBoundingClientRect();
      var p = ((x - r.left) / r.width) * 100;
      ba.style.setProperty("--p", Math.max(3, Math.min(97, p)) + "%");
    }
    ba.style.setProperty("--p", (ba.getAttribute("data-p") || 50) + "%");
    function start(e){ dragging = true; set(e.touches ? e.touches[0].clientX : e.clientX); }
    function move(e){ if(!dragging) return; set(e.touches ? e.touches[0].clientX : e.clientX); }
    function end(){ dragging = false; }
    ba.addEventListener("mousedown", start);
    ba.addEventListener("touchstart", start, { passive: true });
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("mouseup", end);
    window.addEventListener("touchend", end);
  }
  function boot(){ var l = document.querySelectorAll(".ba2"); for (var i=0;i<l.length;i++) initBA(l[i]); }
  if (document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
})();
